import React, { useState, useEffect, useRef } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {
    Chip,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    Grid,
    TextField,
    withStyles,
    Select,
    MenuItem,
    Dialog,
} from "@material-ui/core";
import Fade from "@material-ui/core/Fade";
import Backdrop from "@material-ui/core/Backdrop";
import Loader from "../../components/Loader2";
import SendIcon from "@mui/icons-material/Send";
import Modal from "@mui/material/Modal";
import { useHistory } from "react-router-dom";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { connect } from "react-redux";
import GrivianceModel from "../Grivance/model";
import JiraTicketModal from "./JiraTicketModal";
import ReplyAllIcon from "@mui/icons-material/ReplyAll";
import {
    getGrievance,
    getCenterInfo,
    CreateTaskTicket,
    getExportedGrievance,
} from "../../actions/OffLineSupportActions";
import { generateGrievanceFilterUrl } from "../../healpers/generateUrl";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        buttonContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            marginTop: "50px",
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        modal: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "scroll",
        },
        paper: {
            marginTop: "2rem",
            padding: "0.5rem 2rem",
            width: "100%",
            overflow: "scroll",
            position: "sticky",
        },
        paper1: {
            backgroundColor: theme.palette.background.paper,
            border: "3px solid green",
            borderRadius: "5px",
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            width: "1200px",
        },
        table: {
            maxWidth: "100%",
            overflow: "scroll",
        },
        tableHead: {
            background: "rgb(146, 74, 145)!important",
        },
        imagePaper: {
            position: "absolute",
            backgroundColor: theme.palette.background.paper,
            border: "2px solid #000",
            boxShadow: theme.shadows[1],
        },
        rightContentHeader: {
            width: "30%",
            float: "right",
            textAlign: "right",
            paddingRight: "20px",
        },
        toolbar: {
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 1),
         
            ...theme.mixins.toolbar,
        },
        tableHeadCell: {
            color: "#fff",
            fontWeight: "bold",
            textAlign: "center",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
    })
);

const Input = styled("input")({
    display: "none",
});

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#0E3F6C",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);
function rand() {
    return Math.round(Math.random() * 20) - 10;
}
function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}
interface Props {
    loading: boolean;
    getGrievance: any;
    fetchGrivance: any;
    getCenterInfo: any;
    centerInfo: any;
    CreateTaskTicket: any;
    ticketCategories: any;
    getExportedGrievance: any;
    ExportedGrivance: any;
}

const RaiseTicket: React.FC<Props> = ({
    loading,
    getGrievance,
    fetchGrivance,
    getCenterInfo,
    centerInfo,
    CreateTaskTicket,
    ticketCategories,
    getExportedGrievance,
    ExportedGrivance,
}) => {
    const classes = useStyles();
    const [page, setPage] = useState(0);
    const history = useHistory();
    const [file1, setFile1] = React.useState<any>([]);
    const [openImage, setImageOpen] = React.useState(false);
    const [imageUrl, setImageUrl] = useState("");
    const [modalStyle] = React.useState(getModalStyle);
    const [scrolldown, setScrolldown] = useState<boolean>(false);
    const [start_date, setStart_date] = useState<any>("");
    const [status, setStatus] = useState<any>("");
    const [end_date, setEnd_date] = useState<any>("");
    const [cc_code, setCc_code] = useState<any>("");
    const [center, setCentre] = useState<any>("");
    const [open, setOpen] = useState(false);
    const [grevianceId, setGrevianceId] = useState<any>(null);
    const [fullWidth, setFullWidth] = React.useState(true);
    const [raisedTicketModal, setRaisedTicketModal] = React.useState(false);
    const [category, setCategory] = useState<any>("");
    const [key, setkey] = React.useState<any>(false);
    const [jiramodelOpen, setJiramodelOpen] = useState(false);
    const [ticketId, setTicketId] = useState<any>("");
    const [ticket, setTicket] = useState<any>();
    const [isFileTooLarge, setIsFileTooLarge] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [maxWidth, setMaxWidth] = React.useState("md");
    const [description, setDescription] = useState<any>("");
    const [priority, setPriority] = useState<any>("");
    const [assignTo, setAssignTo] = useState<any>("");
    const [assignToManager, setAssignToManager] = useState<any>("");
    const [TicketData, setTicketData] = useState<any>("");
    const [createdBy, setCreatedBy] = useState<any>("");
    const [sourceType, setSourceType] = useState<any>("System");
    const [ticketIdForFilter, setTicketIdForFilter] = useState<any>("");

    const timer = useRef<any>(0);

    const scrollFunction = () => {
        setScrolldown(!scrolldown);
    };

    useEffect(() => {
        getGrievance();
        getCenterInfo();
    }, []);

    const handleDeskModal = (e: any) => {
        setImageUrl(e);
        setImageOpen(true);
    };
    const handleImageClose = () => {
        setImageOpen(false);
    };
    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        if (newPage > page) {
            let url = fetchGrivance && fetchGrivance.next.split("?")[1];
            getGrievance(`?${url}`);
        } else if (newPage < page) {
            let url = fetchGrivance && fetchGrivance.previous.split("?")[1];
            getGrievance(`?${url}`);
        }
        setPage(newPage as number);
    };
    const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (
            e.key === " " &&
            (!/[a-zA-Z0-9]/.test(e.currentTarget.value) ||
                !/[a-zA-Z0-9]/.test(e.currentTarget.value.slice(-1)))
        ) {
            e.preventDefault();
        }
    };

    const body = (
        <div style={modalStyle} className={classes.imagePaper}>
            <img
                src={imageUrl}
                alt="popup"
                style={{
                    width: "1050px",
                    height: "700px",
                    alignItems: "center",
                    marginBottom: "50px",
                }}
            />
        </div>
    );
    const [enalbleExportBtn, setEnalbleExportBtn] = useState<any>(false)

    const filterGrievance = () => {
        setEnalbleExportBtn(true)
        const body: any = {
            center: center,
            start_date: start_date,
            end_date: end_date,
            status: status,
            lable: createdBy,
            ticket_no: ticketIdForFilter,
        };
        const url = generateGrievanceFilterUrl(body).substring(2);
        getGrievance(`?${url}`);
        getExportedGrievance(`?${url}&export=true`);
        setPage(0);
    };
    useEffect(() => {
        if (!open) {
            getGrievance();
        }
    }, [open]);

    const handleClick = (bookingid: number, data: any) => {
        setOpen(true);
        setGrevianceId(bookingid);
        setTicketData(data);
    };

    const raisedTicket = () => {
        setRaisedTicketModal(true);
    };

    const sendTo = `${assignTo},${assignToManager}`;

    const handleHelpData = async () => {
        setIsButtonDisabled(true);
        const formData = new FormData();
        formData.append("screen_shot", file1);
        formData.append("description", description);
        formData.append("priority", priority);
        formData.append("grievance_type", category);
        formData.append("send_to", sendTo);
        formData.append("center", center);
        formData.append("source_type", sourceType);
        await CreateTaskTicket(formData);
        setRaisedTicketModal(false);
        getGrievance();
        setAssignTo("")
        setAssignToManager("")
        setDescription("");
        setTimeout(() => {
            setIsButtonDisabled(false);
        }, 10000);
    };

    const exportData = () => {
        var rows = [];

        //iterate through rows of table
        let row = ExportedGrivance;
        rows.push([
            "Grievance Type	",
            "CC Code",
            "CC Name",
            "Created By",
            "Created Date",
            "Description",
            "Closer Remarks",
            "Status",
        ]);

        for (var i = 0; i < row.length; i++) {
            rows.push([
                row[i]?.grievance_type_name,
                row[i]?.cc_details[0]?.center_code,
                row[i]?.cc_details[0]?.name,
                row[i]?.created_by,
                row[i]?.created_at.substring(0, 10),
                row[i]?.description,
                row[i]?.remark,
                row[i]?.status,
            ]);
        }
        let csvContent = "data:text/csv;charset=utf-8,";

        rows.forEach(function (rowArray) {
            row = rowArray.join(",");
            csvContent += row + "\r\n";
        });

        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "GrivanceList.csv");
        document.body.appendChild(link);

        link.click();
    };


    const fileSelectedHandler1 = (e: any) => {
        const selectedFile = e.target.files[0];

        if (selectedFile) {
            const fileSizeMB = selectedFile.size / (1024 * 1024);

            if (fileSizeMB <= 10) {
                const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
                if (allowedTypes.includes(selectedFile.type)) {
                    setFile1(selectedFile);
                    setIsFileTooLarge(false); // Reset the flag
                } else {
                    setIsFileTooLarge(true);
                }
            } else {
                setIsFileTooLarge(true);
            }
        }
    };

    return (
        <>
            <div style={{ width: "100%", marginTop: "40px" }}>
                <Paper className={classes.paper} elevation={15}>
                    <h3
                        style={{
                            fontWeight: "bold",
                            color: "#333",
                            paddingBottom: "10px",
                            borderBottom: "3px solid #007BFF",
                            display: "inline-block",
                            marginBottom: "20px",
                            letterSpacing: "1px",
                            textTransform: "uppercase",
                            position: "relative",
                            paddingRight: "10px",
                            paddingLeft: "10px",
                        }}
                    >
                        GRIEVANCE
                    </h3>

                    <Grid
                        container
                        spacing={1}
                        direction="row"
                        style={{ alignItems: "left" }}
                    >
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                className="input"
                                name="Ticket_Id "
                                type="text"
                                label="Ticket Id"
                                value={ticketIdForFilter}
                                variant="outlined"
                                onChange={(e) => setTicketIdForFilter(e.target.value as string)}
                                style={{ width: "100%" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <Autocomplete
                                id="center"
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                                        setCentre(obj?.id);
                                    }
                                }}
                                freeSolo
                                blurOnSelect
                                options={centerInfo?.results || []}
                                disableCloseOnSelect
                                getOptionLabel={(option: any) =>
                                    (option?.display_name === null
                                        ? option?.name
                                        : option?.display_name) +
                                    "(" +
                                    option?.center_code +
                                    ")"
                                }
                                loading={loading}
                                onInputChange={(event, newInputValue) => {
                                    clearTimeout(timer.current);
                                    timer.current = setTimeout(() => {
                                        getCenterInfo(`?name_or_code=${newInputValue}`);
                                    }, 1000);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Centre/Code"
                                        variant="outlined"
                                        fullWidth
                                        className="input"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <TextField
                                className="input"
                                name="name"
                                type="date"
                                onWheel={(e: any) => e.target.blur()}
                                label="Start Date"
                                value={start_date}
                                variant="outlined"
                                onChange={(e) => setStart_date(e.target.value as string)}
                                style={{ width: "100%" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                className="input"
                                name="End Date"
                                type="date"
                                label="End Date"
                                value={end_date}
                                variant="outlined"
                                onChange={(e) => setEnd_date(e.target.value as string)}
                                style={{ width: "100%" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <Select
                                variant="outlined"
                                fullWidth
                                value={status ? status : "none"}
                                style={{ height: "38px" }}
                                onChange={(e) => setStatus(e.target.value as string)}
                            >
                                <MenuItem value="none" disabled>
                                    Select Status
                                </MenuItem>
                                <MenuItem value="To Do">To Do</MenuItem>
                                <MenuItem value="Done">Done</MenuItem>
                                <MenuItem value="In Progress">In Progress</MenuItem>
                                <MenuItem value="Assigned to agent">Assigned to agent</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <Autocomplete
                                id="ticket_status"
                                onChange={(event, newValue) => {
                                    let sourceIds: any = [];
                                    if (newValue) {
                                        let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                                        sourceIds = obj.map((item: any) => item.value);
                                    }
                                    setCreatedBy(sourceIds);
                                }}
                                options={[
                                    {
                                        text: "OffLineSupport",
                                        value: "Offlinesupport",
                                    },
                                    {
                                        text: "CCPartner",
                                        value: "CCPartner",
                                    },
                                    {
                                        text: "Sumit Kumar",
                                        value: "sumit.kumar2@redcliffelabs.com",
                                    },
                                ]}
                                freeSolo
                                blurOnSelect
                                aria-required
                                limitTags={1}
                                multiple
                                getOptionLabel={(option: any) => option.text}
                                getOptionDisabled={(option: any) => {
                                    return createdBy.includes(option.value);
                                }}
                                disableClearable
                                disableCloseOnSelect
                                renderInput={(params) => (
                                    <TextField
                                        className="input"
                                        {...params}
                                        label="Create by "
                                        variant="outlined"
                                        style={{ width: "100%", margin: "0", padding: "0" }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4} md={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                fullWidth
                                onClick={filterGrievance}
                            >
                                Filter
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => history.push("/dashboard/os/grievance")}
                            >
                                Reset
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <Button
                                variant="contained"
                                style={{
                                    background: "rgb(47 120 130)",
                                }}
                                fullWidth
                                onClick={raisedTicket}
                            >
                                Raise Ticket
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <Button
                                variant="contained"
                                style={{
                                    background: !enalbleExportBtn ? "gray" : "rgb(48, 68, 75)",
                                }}
                                fullWidth
                                disabled={!enalbleExportBtn}
                                onClick={exportData}
                            >
                                Export Grievance Ticket
                            </Button>
                        </Grid>
                    </Grid>

                    <div
                        style={{
                            padding: "12px",
                            marginTop: "12px",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                            backgroundColor: "#e3f2fd",
                            display: "inline-block",
                            fontSize: "15px",
                            color: "#333",
                        }}
                    >
                        <span style={{ color: "#004d40" }}>
                            📄 To export the Grievance data, please first select the{" "}
                            <strong>Filter</strong> button. The <strong>Export</strong> button will
                            then be enabled automatically.
                        </span>
                    </div>



                    <TableContainer
                        className={classes.tableContainer}
                        component={Paper}
                        style={{ maxHeight: "700px" }}
                    >
                        <Table stickyHeader aria-label="simple table">
                            <TableHead className={classes.tableHead}>
                                <StyledTableRow>
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        Grievance type
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        CC Code
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        CC Name
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        Created By
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        Created date
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        Description
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        Closer Remarks
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        Status
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        Source Type
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        Image Of Grievance
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        Action
                                    </StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {fetchGrivance &&
                                    fetchGrivance?.results?.length > 0 &&
                                    fetchGrivance?.results?.flatMap((data: any) => {
                                        return (
                                            <StyledTableRow>
                                                <StyledTableCell align="center">
                                                    {data?.grievance_type_name}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.cc_details[0]?.center_code}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.cc_details[0]?.name}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.created_by}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.created_at.substring(0, 10)}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.description}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.remark}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.status}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.source_type}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.screen_shot ? (
                                                        <a
                                                            href={data?.screen_shot}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            View
                                                        </a>
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </StyledTableCell>
                                                {data?.status !== "Done" ? (
                                                    <StyledTableCell align="center">
                                                        <ReplyAllIcon
                                                            style={{ color: "#0f636e" }}
                                                            onClick={() => handleClick(data?.id, data)}
                                                        />
                                                    </StyledTableCell>
                                                ) : (
                                                    <StyledTableCell align="center">
                                                        Ticket Closed
                                                    </StyledTableCell>
                                                )}
                                            </StyledTableRow>
                                        );
                                    })}
                            </TableBody>
                            <TableFooter>
                                <TablePagination
                                    rowsPerPageOptions={[]}
                                    colSpan={3}
                                    count={(fetchGrivance && fetchGrivance.count) || 0}
                                    rowsPerPage={fetchGrivance && fetchGrivance.page_size}
                                    page={page}
                                    onPageChange={handleChangePage}
                                />
                            </TableFooter>
                        </Table>
                    </TableContainer>
                </Paper>
                <GrivianceModel
                    open={open}
                    setOpen={setOpen}
                    setGrevianceId={setGrevianceId}
                    grevianceId={grevianceId}
                    TicketData={TicketData}
                />
                {/* <Dialog
          fullWidth={fullWidth}
          maxWidth={"lg"}
          open={raisedTicketModal}
          onClose={() => setRaisedTicketModal(false)}
        > */}
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={raisedTicketModal}
                    onClose={() => setRaisedTicketModal(false)}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={raisedTicketModal}>
                        <div className={classes.paper1}>
                            <div className={classes.toolbar}>
                                <h3
                                    style={{
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        color: "#333",
                                        padding: "10px 20px",
                                        borderBottom: "3px solid #007BFF",
                                        display: "inline-block",
                                        marginBottom: "20px",
                                        letterSpacing: "1px",
                                        textTransform: "uppercase",
                                        backgroundColor: "#f7f7f7",
                                        borderRadius: "8px",
                                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                    }}
                                >
                                    Fill This Form
                                </h3>
                                <h6
                                    style={{
                                        color: "blue",
                                        marginTop: "10px",
                                        padding: "10px 20px",
                                        backgroundColor: "#f0f8ff",
                                        borderLeft: "4px solid #007BFF",
                                        borderRadius: "4px",
                                        fontStyle: "italic",
                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        fontSize: "14px",
                                        lineHeight: "1.5",
                                    }}
                                >
                                    Note: Proper category will help in faster resolution of your
                                    tickets. If unsure please select category as Others
                                </h6>
                                <div className="ScollTask">
                                    <Grid
                                        container
                                        spacing={3}
                                        direction="row"
                                        alignItems="center"
                                        justify="center"
                                        style={{ marginTop: "4px" }}
                                    >
                                        <Grid item xs={12} md={6} sm={4}>
                                            <Autocomplete
                                                id="category"
                                                key={key}
                                                onChange={(event, newValue) => {
                                                    let sourceIds: any = [];
                                                    if (newValue) {
                                                        let obj = JSON.parse(
                                                            JSON.stringify(newValue, null, " ")
                                                        );
                                                        setCategory(obj.id);
                                                    }
                                                }}
                                                blurOnSelect
                                                limitTags={1}
                                                options={ticketCategories.results || []}
                                                disableClearable
                                                disableCloseOnSelect
                                                getOptionLabel={(option: any) => option?.title}
                                                renderInput={(params) => (
                                                    <TextField
                                                        className="input"
                                                        {...params}
                                                        label="Grievance Category"
                                                        variant="outlined"
                                                        style={{
                                                            width: "100%",
                                                            margin: "0",
                                                            padding: "0",
                                                            marginTop: "3px",
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6} sm={4}>
                                            <Autocomplete
                                                id="center"
                                                key={key}
                                                onChange={(event, newValue) => {
                                                    if (newValue) {
                                                        let obj = JSON.parse(
                                                            JSON.stringify(newValue, null, " ")
                                                        );
                                                        setCentre(obj.id);
                                                    }
                                                }}
                                                blurOnSelect
                                                limitTags={1}
                                                options={centerInfo?.results || []}
                                                disableClearable
                                                disableCloseOnSelect
                                                getOptionLabel={(option: any) =>
                                                    (option?.display_name === null
                                                        ? option?.name
                                                        : option?.display_name) +
                                                    "(" +
                                                    option?.center_code +
                                                    ")"
                                                }
                                                loading={loading}
                                                onInputChange={(event, newInputValue) => {
                                                    clearTimeout(timer.current);
                                                    timer.current = setTimeout(() => {
                                                        getCenterInfo(`?name_or_code=${newInputValue}`);
                                                    }, 1000);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Centre"
                                                        variant="outlined"
                                                        fullWidth
                                                        required
                                                        className="input"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={6}>
                                            <Select
                                                variant="outlined"
                                                fullWidth
                                                required
                                                style={{ height: "38px" }}
                                                value={sourceType}
                                                onChange={(e) => setSourceType(e.target.value as string)}
                                            >
                                                <MenuItem value="none" disabled>
                                                    Select Source Type
                                                </MenuItem>
                                                <MenuItem value="WhatsApp">WhatsApp</MenuItem>
                                                <MenuItem value="Email">Email</MenuItem>
                                                <MenuItem value="inbound_call">Inbound Call</MenuItem>
                                                <MenuItem value="System">
                                                    System
                                                </MenuItem>
                                            </Select>
                                        </Grid>
                                        <Grid item xs={12} md={6} sm={6}>
                                            <TextField
                                                name="Assign To"
                                                type="email"
                                                value={assignTo}
                                                className="input"
                                                label="Assign To Email"
                                                variant="outlined"
                                                onChange={(e) => setAssignTo(e.target.value as string)}
                                                style={{ width: "100%" }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6} sm={6}>
                                            <TextField
                                                name="Assign To"
                                                type="email"
                                                value={assignToManager}
                                                className="input"
                                                label="Assign To Manager Email"
                                                variant="outlined"
                                                onChange={(e) =>
                                                    setAssignToManager(e.target.value as string)
                                                }
                                                style={{ width: "100%" }}
                                            />
                                        </Grid>
                                        {loading ? (
                                            <Loader />
                                        ) : (
                                            <Grid item xs={12} md={6} sm={6}>
                                                <sup
                                                    style={{
                                                        fontSize: "11px",
                                                        marginLeft: "15px",
                                                        marginTop: "15px",
                                                        background: "#fff",
                                                        color: "rgba(0, 0, 0, 0.54)",
                                                        letterSpacing: "0.00938em",
                                                    }}
                                                >
                                                    Upload Grievance Image/Pdf(Max 10mb File)
                                                </sup>
                                                <input
                                                    className="input"
                                                    key={key}
                                                    style={{
                                                        width: "100%",
                                                        height: "40px",
                                                        marginTop: "-15px",
                                                        padding: "12.5px 14px",
                                                        border: "1px solid rgba(0, 0, 0, 0.23)",
                                                        borderRadius: "5px",
                                                    }}
                                                    type="file"
                                                    name="file"
                                                    id="file"
                                                    accept=".jpg, .jpeg, .png, .pdf"
                                                    onChange={fileSelectedHandler1}
                                                />
                                            </Grid>
                                        )}
                                        <Grid item xs={12} sm={12} md={12}>
                                            <textarea
                                                aria-label="Grievance Description "
                                                rows={3}
                                                value={description}
                                                onChange={(e) =>
                                                    setDescription(e.target.value as string)
                                                }
                                                placeholder="Grievance Description"
                                                style={{ width: "100%", height: "220px" }}
                                                onKeyDown={handleKeyDown}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={2}
                                        direction="row"
                                        style={{ alignItems: "left" }}
                                    >
                                        <Grid
                                            item
                                            xs={12}
                                            md={6}
                                            sm={3}
                                            style={{ textAlign: "right" }}
                                        >
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={handleHelpData}
                                                startIcon={<SendIcon />}
                                                disabled={
                                                    category?.length === 0 ||
                                                    description === "" ||
                                                    isFileTooLarge ||
                                                    isButtonDisabled ||
                                                    center === ""
                                                }
                                                style={{ width: "170px" }}
                                            >
                                                Submit
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Button
                                                variant="contained"
                                                onClick={() => {
                                                    setDescription("");
                                                    setkey(!key);
                                                    setSourceType("");
                                                    setAssignTo("");
                                                    setAssignToManager("");
                                                }}
                                                startIcon={<RestartAltIcon />}
                                            >
                                                Reset Form
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                            <Modal
                                open={openImage}
                                onClose={handleImageClose}
                                aria-labelledby="simple-modal-title"
                                aria-describedby="simple-modal-description"
                            >
                                {body}
                            </Modal>
                            {jiramodelOpen ? (
                                <JiraTicketModal
                                    open={jiramodelOpen}
                                    setOpen={setJiramodelOpen}
                                    ticketId={ticketId}
                                    ticket={ticket}
                                />
                            ) : (
                                ""
                            )}
                        </div>
                    </Fade>
                </Modal>
            </div>
        </>
    );
};

const mapStateToProps = (state: any) => ({
    fetchGrivance: state.OffLineSupporteReducer.fetchGrivance,
    centerInfo: state.OffLineSupporteReducer.centerInfo,
    ticketCategories: state.OffLineSupporteReducer.ticketCategories,
    ExportedGrivance: state.OffLineSupporteReducer.ExportedGrivance
});

export default connect(mapStateToProps, {
    getGrievance,
    getCenterInfo,
    CreateTaskTicket,
    getExportedGrievance
})(RaiseTicket);